import { RigidBody } from "@react-three/rapier";
import { useGLTF, useAnimations} from "@react-three/drei";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader.js";
import { useEffect, useRef} from "react";
import { useTheme } from "../../contexts/ThemeContext";

export default function Character({ animation }) {
    const group = useRef();
    const {theme} = useTheme();

    const { scene, animations } = useGLTF("./mage_compressed-v1.glb", true, false, (loader) => {
        const dracoLoader = new DRACOLoader();
        dracoLoader.setDecoderPath('https://www.gstatic.com/draco/versioned/decoders/1.5.5/');
        dracoLoader.setDecoderConfig({ type: 'js' });
        loader.setDRACOLoader(dracoLoader);
    });

    // Can probably compress the mage character model even more by 
    // keeping only necessary action animations
    const { actions } = useAnimations(animations, group);
    
    // Add shadows to entire character model
    useEffect(() => {
        scene.traverse((child) => {
            if(child.isMesh){
                child.castShadow = true;
                child.receiveShadow = true;
            }
        })
    }, [scene])
    
    // Handle Animation and Transitions
    useEffect(() => {
        if (actions[animation]) {
            actions[animation].reset().fadeIn(0.24).play();
            return () => actions[animation]?.fadeOut(0.24);
        }
    }, [animation, actions]);

    return (
        <RigidBody 
            type="dynamic" 
            colliders={false}
        >
            <group ref={group}>
                <primitive
                    object={scene}
                    scale={[0.2, 0.2, 0.2]}
                    position-y={-0.3}
                />
            </group>
            { theme === 'dark' ? (
                <pointLight 
                    intensity={1} 
                    position-y={0.7}    
                    position-z={0}     
                    position-x={0} 
                    color="white" 
                />
            ) : (<></>)}
        </RigidBody>
    );
}
